import { useState, useEffect } from "react"

export function useMounted() {
    const [ isMounted, setIsMounted ] = useState(false)
    useEffect(() => {
        setIsMounted(true)
    }, [])
    return isMounted
}